<template>
  <!-- 外部账号导入组件 -->
  <yxtbiz-import-proc
    :template-url="templateUrl"
    @uploaded="uploaded"
    :app-code="udp"
    :upload-config="uploadConfig"
    :on-error="onError"
  >
    <div v-if="importResult && importResult.isSuccess" slot="success">
      <yxt-row type="flex" align="middle" class="color-gray-10 yxt-upload-item-title">
        <span class="yxt-color-success">{{ importResult.successCount }}</span>
        {{$t('pc_biz_udp_import_tip_successcount',/* 条导入成功 */)}}
        <template v-if="importResult.failedCount">
          {{$t('pc_biz_udp_tip_comma',/* ， */)}}<span class="yxt-color-danger">{{ importResult.failedCount }}</span>
          {{$t('pc_biz_udp_import_tip_failedcount',/* 条导入失败 */)}}
        </template>
        <template v-if="importResult.repeatCount">
          {{$t('pc_biz_udp_tip_comma',/* ， */)}}<span class="yxt-color-danger">{{ importResult.repeatCount }}</span>
          {{$t('pc_biz_udp_import_tip_repeatcount',/* 条重复数据 */)}}
        </template>
      </yxt-row>
      <yxt-row type="flex" align="middle" class="standard-size-12 lh20 mt4" v-if="importResult.successCount">
        <yxt-link :underline="false" type="success">
          <i class="yxt-icon-success" />
        </yxt-link>
        <span class="color-gray-8 ml3">{{$t('pc_biz_import_tip_importsuccess',/* 导入成功 */)}}</span>
        <yxt-link class="standard-size-12 ml8" type="primary" :underline="false" @click="downloadError(importResult.filePath)" v-if="importResult.filePath">
          {{$t('pc_biz_udp_import_btn_downloadfaileddata',/* 下载失败数据 */)}}
        </yxt-link>
      </yxt-row>
       <yxt-row type="flex" align="middle" class="standard-size-12 lh20 mt4" v-else>
        <yxt-link :underline="false" type="danger">
          <i class="yxt-icon-error" />
        </yxt-link>
        <span class="color-gray-8 ml3">{{$t('pc_biz_import_tip_importfailed',/* 导入失败 */)}}</span>
        <yxt-link class="standard-size-12 ml8" type="primary" :underline="false" @click="downloadError(importResult.filePath)" v-if="importResult.filePath">
          {{$t('pc_biz_udp_import_btn_downloadfaileddata',/* 下载失败数据 */)}}
        </yxt-link>
      </yxt-row>
    </div>
  </yxtbiz-import-proc>
</template>

<script>
import { saveVisitors, getExternalUsersDownload } from './service.js';
import commonUtil from 'yxt-biz-pc/packages/common-util';
export default {
  name: 'YxtbizVisitorImportor',
  data() {
    return {
      uploadConfig: {
        appCode: 'udp'
      },
      importResult: null,
      fileId: '',
      templateUrl: ''
    };
  },
  computed: {
    lang() {
      return commonUtil.getLanguage();
    }
  },
  async created() {
    this.getExternalUsersDownload();
  },
  methods: {
    async getExternalUsersDownload() {
      try {
        const { filePath } = await getExternalUsersDownload();
        this.templateUrl = filePath;
      } catch (error) {
        this.templateUrl = this.defaultTemplateUrl();
      }
    },
    defaultTemplateUrl() {
      const base = `${this.$staticBaseUrl}ufd/55a3e0/core/pc/other/visitor-import-temp`;
      const langSuffix = this.lang !== 'zh' ? `_${this.lang}` : '';
      return `${base}${langSuffix}.xlsx`;
    },
    onError(e, file) {
      console.log(e, file);
    },
    uploaded(next, file) {
      if (file.id === this.fileId) return;
      this.fileId = file.id;
      saveVisitors({
        fileId: file.id
      }).then(res=>{
        this.importResult = Object.assign({isSuccess: true}, res) ;
        this.$emit('getUserList', {
          fileId: file.id, // 文件id
          data: res.datas, // 导入成功的数据
          totalCount: res.totalCount, // 总数量
          successCount: res.successCount, // 成功数量
          repeatCount: res.repeatCount// 重复数量
        });
        next();
      }).catch(e=>{
        next({
          isSuccess: false,
          title: this.$t('pc_biz_msg_import_failed'),
          message: (e && e.error) ? e.error.message : ''
        });
      });

    },
    // 下载异常说明
    downloadError(url) {
      if (this.clicked) {
        this.$message.warning(this.$t('pc_biz_import_msg_downloading'/* 正在下载，请稍后 */));
      } else {
        window.location.href = url;
      }
      this.clicked = true;
      this.throttle(() => {
        this.clicked = false;
      });
    },
    throttle(method) {
      clearTimeout(method.tId);
      method.tId = setTimeout(() => {
        method();
      }, 1000);
    }
  },
  watch: {
  }
};
</script>

<style lang="scss" scoped></style>
